import {
    ChangeDetectionStrategy,
    Component,
    signal,
    ViewEncapsulation,
    input,
    inject,
    computed,
} from '@angular/core';
import { IEkomiWidgetBlock } from './ekomi-widget.model';
import { PlatformService } from '@seven1/angular/ssr';
import { HttpClient } from '@angular/common/http';
import * as serverEkomiData from '../../../../../../../public/data/ekomiData.json';
import { NgOptimizedImage } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { ekomiDataType } from '../ekomi/ekomi.component';


@Component({
    selector: 'div[app-ekomi-widget]',
    templateUrl: '../ekomi/ekomi.component.html',
    styleUrl: '../ekomi/ekomi.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgOptimizedImage
    ],
    host: {
        class: 'flex justify-center items-center',
        '[class]': 'classes()',
        '[attr.id]':'block().componentId'
    }
})
export class EkomiWidgetComponent {
    private _platformService = inject(PlatformService);
    private _tailwind = inject(TailwindService);
    private _http = inject(HttpClient)

    block = input.required<IEkomiWidgetBlock>();
    data = this._platformService.isBrowser
        ? toSignal(this._http.get<ekomiDataType>('/data/ekomiData.json'), {
            initialValue: serverEkomiData as ekomiDataType,
        })
        : signal<ekomiDataType>(serverEkomiData);


    classes = computed(() => {
        const block = this.block();
        return [
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getDisplayClasses(block),
        ];
    });

}
